import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

export default function Spinner({
  className,
  children,
  ...props
}: ComponentProps<"span">) {
  return (
    <span
      className={twMerge(
        "inline-block size-6 rounded-full border-4 border-primary border-l-transparent animate-spin",
        className
      )}
      {...props}
    />
  );
}
